import noccarcLogo from "../images/noccarc_logo.jpeg";
import kirloskarLogo from "../images/kirloskar_oil_engines_ltd_logo.jpeg";
import vitLogo from "../images/images.png";

export const Bio = {
  name: "Vishwas Jain",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Android/IOS Developer",
  ],
  description:
    "Enjoy solving intricate technical challenges, particularly those related to system design, scalability, and performance",
  github: "https://github.com/vish899victor",
  resume:
    "https://drive.google.com/file/d/1lJcu-T20UiZ0YyDWmSO5pC9f69xl7UUY/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
  insta: "https://www.instagram.com/vishw_victor/",
  email: "jainvishwas2011@gmail.com",
  phone: "+91 95525 95671",
  location: "Pune, India",
};

export const certifications = [
  { org: "Coding Ninjas", name: "Basic & Advanced Data Structures in C++" },
  { org: "IBM · Coursera", name: "Full Stack Developer" },
  { org: "LinkedIn Learning", name: "Advance Your Skills in Natural Language Processing" },
  { org: "LinkedIn Learning", name: "AWS Certified Solutions Architect" },
];

export const achievements = [
  "JEE Main 2021 — 96 percentile",
  "Class X, CBSE 2019 — 94%",
  "Class XII, HSC 2021 — 90%",
];

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      // {
      //   name: "Material UI",
      //   image:
      //     "data:image/png;base64,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",
      // },

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      // {
      //   name: "Kotlin",
      //   image:
      //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      // },
      // {
      //   name: "XML",
      //   image:
      //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      // },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn3.iconfinder.com/data/icons/social-media-2169/24/social_media_social_media_logo_git-1024.png",
      },
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/19/C_Logo.png",
      },

      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
      },
      {
        name: "Javascript",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAACUCAMAAAAnDwKZAAAAdVBMVEX33x4AAAD85B/lzxzJthk/OQcZFwP/6B//5h+NfxH/6yD64R7/7SDy2x7cxxsPDgJ8cA/ArRdKQwlaUQtlXAxTSwq4pxYuKQapmhXt1h2WiBIjIAQ1MAZvZA3SvhqEdxCfkBMeGwQoJAV2ag6xoRYVEwMJCAJsERP6AAAFAklEQVR4nO2a6ZKyOhBAoQEDBFAUEZDFGf18/0e84DKSQAigYaZu9fk1NRZy7GydTjQNQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAE+RtQALsBgC74UsIifjW1XTDK8JIkySU0A+raC2mmmcMQCN4LoIXFNj9e9Yb1Md9Gl3SRYFIj1xlM6BXUykLvsjNTewFFi3npqk+RemXUI9iwD13VgRyjCGklEGwo0t64L6poG9sBQ123ArWNLVeE0hK4Pfk2lTpKFe3yKjGsUeooU6T+cCvfyQ2F/VEaxfMIw3r2SdWNa4kihKMMdb3yfkvRPYxU1EtlTT2sSOKxhnqhrKUlij2Lytcu2q86/63UdcZBRSj5dl5VBgEAYmTM0r4vBzIkpYr2hTM8mO79Y+oar7RilWkq18BBRZpxMWxN0UCfC/fWUJuSDSr6XALmkPaT3q2j5heFbTxCcc8qshPS7dHCIPxXLqqYsunumhu1dmyZC2wOhhXZAb3WOB/fVx5CqSIbxWtn7ltkfzWsyGU58RJBm6bo71jFjeItwAxFbcMq6pffCOPwAnjiFPVQ9SQ4WbGb6DiwVA1inCL/YcM6TBeO5PRkTN8n1P07irbZo1injE6qNLeZoqgR0cZgE9KlRrdseyXcGax3F7JMkVG6j+anxjaJscTIkSmCMaCoW9kCicSIgsmQYx1J5QNHXnayw3+DjlvVFcYRxTvon3leVGoDOaYESgJJ6elQquyRowrJw2Xamn+hQsdRihqFUBLIRJ3jOMW6sf3se9AxVlYFHatYB9JwhhTXogeXU2yKJH420NwHVYWnCYrNYZwR7wSGdWahqAo6SfF2TFkWR0FTK6qCTlSsAS/I+o85FG0Qpys2J5Zp0hfJ3FDSG+co1hCS9EQyVhLGmYq1ZM8cdFYyf89WrId358DjqmTbNV+xOU9Yc45/qS8+HPljdNGVAOWKVFSA6Owawg+MF9qpEMoVieaIZhObU3w/l6hTAX4hpQa7U/7ilwjwL7leCaID3Jr9duXMThPd4V5GA/Ylx4AtuYN5W5QFxU+wPqpIPbP5Qu7kmN+YHNptSokfrR/mvU1I+L74TkNTEtxLSBZbQnC5lD9vCxivo6G8z7EzM76TSNja6bmqnph3edy1gu1PRgUkbvc0K+g0ItW4cxndnz3pAJit2n+7wxC+Drv5WSD4bd93TLk+4neKKbNXFxKw33Whj0BSEn9xL3lOG331pnNpv2ZIePacFsXs0XLiN0aR6bmEuJ6x6RwsPyclyp253AMZhZp3u/zmeuWmW9e7zOyKtOwreOyLgu9IN/mfx4igBrGKNo5z7s1p5+eLZHDnxpK84tBZgKVs3lihR1wGumO14kAl97A6rIP5Uw6EYx2zdn+Xle14nHd2gHTcfaA632OaasL9kpp8/qTYKJK+odGFv/rVzavFHN9o5gYY1a+cThgEhxpjft4MR3EV4cm5Jwy2rLT44PqB6h1ooqumP4a9uTX4ktLije1HaqBU6xyLMpw6CfnjOTCl98bOn7qr6hqRcPKJAnEGAF4yNNrWu8D72K4KqNm/YuzC4YI68UPhCVFl0o/WIICmyfbQXrOv31ZmyCv+QP24yI/Mvvl6zKMw/axgAyVeaiZZdS6K4lxlp9BwRx6S2R4E4cmpiqim2DinOABP0fk5BUKo30DtaSeN9ZNwf9Kv/7R/5TIHgvwv+Q/iHUL2DZeO+QAAAABJRU5ErkJggg==",
      },
      {
        name: "Linux",
        image:
          "https://images.icon-icons.com/2235/PNG/512/linux_os_logo_icon_134670.png",
      },
      {
        name: "Kafka",
        image:
          "https://dt-cdn.net/hub/logos/apache-kafka.png",
      },
      {
        name: "Redis",
        image:
          "https://logodix.com/logo/631153.png",
      },
      {
        name: "AWS",
        image:
          "https://images.icon-icons.com/2407/PNG/512/aws_icon_146074.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      // {
      //   name: "Docker",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      // },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      // {
      //   name: "VS Code",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      // },
      {
        name: "Postman",
        image:
          "https://cdn-1.webcatalog.io/catalog/postman/postman-icon-filled-256.webp?v=1714775526158",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/3000/figma-logo-1024.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: noccarcLogo,
    role: "Software Engineer I",
    company: "Noccarc Robotics",
    date: "June 2025 - Present",
    desc: "Building HorizonView, a remote ventilator monitoring platform, and the systems around it.",
    points: [
      "Shipped critical HorizonView features on React and React Native, with a Node.js and PostgreSQL backend, cutting load time by about 50%.",
      "Run AWS infrastructure (EC2, CloudFront, S3, Aurora/RDS, Route 53) at 99.5% uptime for live vitals such as SpO2, pressure, and heart rate.",
      "Designed a new OTA update architecture so ventilators can receive software, firmware, and OS upgrades remotely using Python, multithreading, and ZeroMQ.",
      "Built a Kafka, Redis, and WebSocket pipeline that ingests, caches, and plots live graphs in under 500ms.",
      "Delivered a TypeScript and TypeORM CRM for sales and service teams, cutting operational errors by 70–80%.",
      "Built a Hospital Management System that maps ventilators to beds and wards, improving asset tracking by about 80%.",
    ],
    skills: [
      "AWS",
      "React Js",
      "React Native",
      "JavaScript",
      "Python",
      "Linux",
      "Node Js",
      "Express Js",
      "Kafka",
      "Redis",
      "Psql",
      "Multithreading",
      "ZeroMQ (Router-Dealer/Pub-Sub)"
    ],
    //doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    img: noccarcLogo,
    role: "Software Engineer Intern",
    company: "Noccarc Robotics",
    date: "Sep 2024 - June 2025",
    desc: "Supported the systems that keep critical healthcare software reliable.",
    points: [
      "Worked on Linux systems and internal tools for deployment, logging, monitoring, and automation.",
      "Partnered with Hardware, Clinical, and Firmware teams on reliability and compliance in a healthcare environment.",
    ],
    skills: [
      "React Js",
      "React Native",
      "JavaScript",
      "Python",
      "Linux",
      "Node Js",
      "Express Js",
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 2,
    img: kirloskarLogo,
    role: "Data Analyst Intern",
    company: "Kirloskar Oil Engines Limited",
    date: "June 2024 - Sep 2024",
    desc: "Turned service and sales data into dashboards and forecasting models.",
    points: [
      "Built the INSIA dashboard for revenue, part sales, service response, AMC, defective material, customer delight, and warranty.",
      "Trained sales forecasting models in Python with ARIMA and Holt exponential smoothing for inventory and supply chain planning.",
      "Segmented customers with RFM analysis so sales could focus on high-value accounts.",
    ],
    skills: [
      "Python",
      "Machine Learning",
      "Big Data",
      "Data Analytics",
      "PowerBI"
    ],
  },
];

export const education = [
  {
    id: 0,
    img: vitLogo,
    school: "Vishwakarma Institute of Technology, Pune",
    date: "2021 - 2025",
    grade: "8.78 CGPA",
    desc: "Operating System, Database Management, Object-Oriented Programming, Computer Networks, Data Structures & Algorithms, Data Science, Artificial Intelligence, Machine Learning",
    degree: "BTech, ARTIFICIAL INTELLIGENCE & DATA SCIENCE",
  },
];

export const projects = [
  {
    id: 9,
    title: "Crowd Funding Platform",
    date: "Jan 2024 - May 2024",
    description:
      "Developed a decentralized crowdfunding platform using Solidity, Hardhat, Next.js, Ethers.js, Node.js, and the Polygon blockchain, supporting both reward-based and equity-based models. Smart contracts were written in Solidity and deployed to the Polygon testnet and mainnet using Hardhat, with robust testing and security practices including reentrancy protection. The frontend, built with Next.js and styled for clean UI/UX, interacts with the blockchain via Ethers.js. Implemented core features like campaign creation, fund contribution, and withdrawal, along with user authentication and role-based access control. Configured the platform to use Polygon RPC endpoints and ensured seamless integration between frontend and blockchain layers. Published in the International Journal of Computer Engineering & Technology (IJCET), 2024.",
    image:
      "https://howtoapplyforgrants.com/wp-content/uploads/2023/07/Shutterstock_2235741015.png",
    tags: [

      "Node Js",
      "Next Js",
      "Polygon",
      "Solidity",
      "HardHat",
      "React Js",
      "Tailwind CSS",
      "Blockchain"

    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 0,
    title: "Skill-Connect : A Freelancing Website",
    date: "June 2024 - Sep 2024",
    description:
      "Skill-Connect is an innovative freelancing platform built using the MERN stack (MongoDB, Express.js, React.js, Node.js) that connects skilled professionals with businesses in need of their services. It offers a seamless user experience for posting jobs, bidding on projects, secure communication, and real-time collaboration. The platform features user authentication, role-based dashboards, integrated chat, and project tracking tools to ensure transparency and efficiency. Designed to bridge the gap between freelancers and clients, Skill-Connect fosters a productive environment to manage and complete projects effectively. Published in the International Journal of Computer Engineering & Technology (IJCET), 2024.",
    image:
      "https://i.pinimg.com/736x/9c/25/09/9c25096fea2bad47b6332aef4fb73e28.jpg",
    tags: ["Node Js",
      "Express Js",
      "MongoDB",
      "React Js"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 1,
    title: "Future Glam",
    date: "Sep 2023 - Dec 2023",
    description:
      "Developed a career prediction web application using Python, Django, and Machine Learning algorithms (Decision Tree, KNN, Classification) to assist students in identifying suitable career paths post-secondary education. Implemented a skill assessment module, ML-based prediction engine, and an outcome analysis dashboard. Utilized scikit-learn, Pandas, NumPy, and Matplotlib for data processing and visualization. Integrated PostgreSQL for robust and scalable database management. Designed a responsive front-end with a user-friendly interface to enhance accessibility and user engagement. Published and presented at IEEE CONIT 2023, the 3rd International Conference on Intelligent Technologies.",
    image:
      "https://w7.pngwing.com/pngs/209/885/png-transparent-finding-the-right-career-path-career-counseling-job-career-pathways-student-text-people-logo.png",
    tags: [
      "HTML",
      "CSS",
      "Decision Tree",
      "Pyython",
      "Django",
      "Machine Learning",
      "Psql"
    ],
    category: "web app",
    github: "https://github.com/vish899victor/FUTURE-GLAM",
    //webapp: "https://vexa-app.netlify.app/",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 2,
    title: "Corona Map",
    date: "May 2021 - June 2021",
    description:
      "Developed an interactive COVID-19 tracking map using HTML, JavaScript, and public datasets to visualize real-time coronavirus cases across different regions. Integrated live data with map APIs to dynamically display confirmed cases, recoveries, and deaths using color-coded markers and tooltips. Implemented responsive design for better usability across devices",
    image:
      "https://www.un.org/sites/un2.un.org/files/field/image/1583952355.1997.jpg",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/vish899victor/Corona-Map",
    //webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 3,
    title: "Spidy - A Virtual Assistant",
    date: "Jan 2022 - May 2022",
    description:
      "Built Spidy, a fully-featured virtual voice assistant in Python capable of performing tasks such as sending emails, searching the web, playing music, and launching desktop applications through voice commands. Utilized libraries like SpeechRecognition, pyttsx3 (text-to-speech), smtplib (email automation), webbrowser (web control), os (system operations), datetime, wikipedia, and playsound to enable intelligent and responsive voice-based interaction. Designed to enhance desktop productivity with a hands-free, interactive assistant experience",
    image:
      "https://miro.medium.com/v2/resize:fit:735/1*pDN0qulYbAO6HLrWKAEgrQ.jpeg",
    tags: ["Python", "Machine Learning", "SpeechRecognition", "smtplib" , "pyttsx3"],
    category: "machine learning",
    github: "https://github.com/vish899victor/SPIDY--The-Virtual-Assistant",
    //webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 10,
    title: "Ad-Predictor-through-CTR",
    date: "Jun 2023 - Jul 2023",
    description:
      "Developed a machine learning model in Python to predict whether a user would click on an advertisement based on attributes like age, income, internet usage, and time spent on site. Utilized Pandas and NumPy for data preprocessing, and Matplotlib for data visualization. Applied Logistic Regression using Scikit-learn, achieving an accuracy of 92.5%. Leveraged Seaborn for enhanced visual insights and used train_test_split for effective model validation. The project showcases a complete ML pipeline from raw dataset to accurate prediction",
    image:
      "https://www.shutterstock.com/image-vector/media-planning-effective-ads-strategy-600nw-2477548453.jpg",
    tags: ["Python", "Machine Learning", "Pandas", "NumPy" , "Matplotlib" , "Regression" , "Seaborn" , "Scikit-learn"],
    category: "machine learning",
    github: "https://github.com/vish899victor/Ad-Predictor-through-CTR",
    //webapp: "https://github.com/rishavchanda/Job-finder-App",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 4,
    title: "Real Estate Housing Price Predictore",
    date: "Sep 2023 - Nov 2023",
    description:
      "The is a machine learning project developed using Python and Scikit-Learn that predicts housing prices based on various features such as crime rate, number of rooms, tax rate, and accessibility to highways. The dataset, based on the Boston Housing dataset, is preprocessed using strategies like median imputation, standardization, and feature engineering (e.g., adding TAXRM). The model leverages algorithms like Linear Regression, Decision Tree, and Random Forest Regressor, with Random Forest showing the best performance. Cross-validation is used to evaluate model performance and prevent overfitting. The final model is saved using Joblib and deployed to make real-time price predictions based on user input",
    image:
      "https://img.freepik.com/premium-vector/housing-price-rising-up-real-estate-property-growth-concept-businessman-running-rising-green_997622-10002.jpg",
      tags: ["Python", "Machine Learning", "Pandas", "NumPy" , "Matplotlib" , "Decision Tree" , "Random Forest Regressor" , "Scikit-learn"],
      category: "machine learning",
    github: "https://github.com/vish899victor/Real-Estate-Housing-Price-Predictor",
    //webapp: "https://whatsapp-clone-rishav.web.app",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
  {
    id: 5,
    title: "Deep Fake Detection",
    date: "Jan 2025 - May 2025",
    description:
      "This project focuses on developing a robust DeepFake detection system using a hybrid CNN-LSTM architecture. Leveraging publicly available datasets like FaceForensics++, DFDC, and Celeb-DF, the system extracts spatial features using pre-trained CNN models and captures temporal inconsistencies through LSTM networks. The combined model effectively identifies DeepFake videos by analyzing both frame-level artifacts and motion anomalies over time. Techniques such as data augmentation, adversarial training, and real-time optimization are employed to enhance accuracy and robustness. Evaluated using precision, recall, F1-score, and AUC, the system shows strong performance against various DeepFake manipulations. Future work includes incorporating attention mechanisms and transformer-based models to further improve detection capabilities",
    image:
      "https://miro.medium.com/v2/resize:fit:1200/1*GJXo9hlFKeSTMvySMmo7pw.jpeg",
      tags: ["Python", "Machine Learning", "Pandas", "NumPy" , "Matplotlib" , "CNN" , "LSTM" , "Scikit-learn"],
      category: "machine learning",
   // github: "https://github.com/vish899victor/Real-Estate-Housing-Price-Predictor",
    //webapp: "https://whatsapp-clone-rishav.web.app",
    member: [
      {
        name: "Vishwas Jain",
        img: "https://avatars.githubusercontent.com/u/111347982?v=4",
        linkedin: "https://www.linkedin.com/in/vishwas-jain-a7aa11234/",
        github: "https://github.com/vish899victor",
      },
    ],
  },
];


